import { array, mixed, object, string } from 'yup';

export const createChannelSchema = object().shape({
  name: string()
    .max(50, 'Maximum characters for a display name is 50')
    .required('Please enter a name'),
  description: string().max(
    150,
    'Maximum characters for a biography name is 150'
  ),
  tags: mixed().when('isArray', {
    is: Array.isArray,
    then: array().of(string()),
    otherwise: string(),
  }),
  isPrivate: string().oneOf(['public', 'private']),
});
